import { render, staticRenderFns } from "./warranties.vue?vue&type=template&id=7bc45d00"
import script from "./warranties.vue?vue&type=script&lang=js"
export * from "./warranties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports